import {
    FETCH_COMMENTS,
    FETCH_COMMENTS_SUCCESS,
    FETCH_COMMENTS_FAILED,
} from "../store/types";

const INITIAL_STATE = {
    comments: [],
    loading: false,
    error: {
        flag: false,
        msg: null
    }
}

export const commentsreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_COMMENTS:
            return {
                ...state,
                loading: true
            };
        case FETCH_COMMENTS_SUCCESS:
            return {
                ...state,
                comments: action.payload,
                loading: false
            };
        case FETCH_COMMENTS_FAILED:
            return {
                ...state,
                comments: [],
                loading: false,
            };
        default:
            return state;
    }
};